<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
        <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <b-col>
                <h1>{{ecmResourceStrings.ttlLastRDBMSExecStatus}}</h1>
            </b-col>
        </b-row>
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <b-col >
                <SettingsTable 
                    :rows="partitions"
                    :columns="columns"
                    :actions="actions"
                    :customOptions="customOptions"
                    @sort="sort">
                    <template slot="table-header">
                        <h1 class="text-center OT-table-title"></h1>
                    </template>
                    </SettingsTable>
                </b-col>
            </b-row>
    </b-col>
</b-row>
</template>

<script>
import ECMErrorDialog from '../modals/ECMCrawlerMessageDlg.vue';
import { showMessage} from '../../utils/commonECM.js';
import SettingsTable from '@/ecm/components/ECMSettingsTable.vue';
import ecmRepositories from '@/ecm/collections/ecmrepositories.js';
import Collection from '@/collections/basic.js';
import axios from 'axios';
import { sortOn } from '../../utils/commonECM.js';
import { getguivalue } from '../../utils/commonECM.js';

export default {
   
    data() {
        return {
            messageDlg:false,
            ecmResourceStrings: require('../../utils/resourceECM.js'),  
            ecmpartitions: new Collection({paginated: false}),
            sortDir:'asc',
            ecmRepositories: new ecmRepositories({paginated: false }),
            customOptions: [],
            connections:[],
            columns: [
            {
                name: 'partition',
                label: 'Partition',
                sortable: true,
                editable:false,
                render(row) {
                    return row.partitiondescription;
                }
            },{
                name: 'id',
                label: 'ID',
                sortable: true,
                editable:false,
                width:'10%',
                render(row) {
                    return row.ecmrepositoryid;
                }
            },{
                name: 'type',
                label: 'Type',
                sortable: true,
                editable:false,
                render(row) {
                    return row.ecmrepositorytype;
                }
            },{
                name: 'connection',
                label: 'RDBMS Connection',
                sortable: true,
                editable:false,
                render(row) {
                    return row.connectiondescr;
                }
            },{
                name: 'operation',
                label: 'Operation Type',
                sortable: true,
                editable:false,
                render(row) {
                    return row.guioperationType;
                }
            },{
                name: 'status',
                label: 'Status',
                sortable: true,
                width:'10%',
                editable:false,
                render(row) {
                    return row.isRunning;
                }
            }],
             loaded: false,
              actions: [{
                    name: 'details',
                    label: 'Details',
                    callback: (row) => { this.showDetails(row); }
            }],
        }
    },

    components: {
        SettingsTable,
        ECMErrorDialog,
    },
   
    methods: {
        refresh(){
            this.loaded = true;
        },

        sort(colNumber, dir)
        {
            var that = this;
            that.sortDir = dir;
            if(colNumber == 0)
                that.ecmpartitions.resources.sort(sortOn('partitiondescription', dir));
            if(colNumber == 1)
                that.ecmpartitions.resources.sort(sortOn('ecmrepositoryid', dir));
            if(colNumber == 2)
                that.ecmpartitions.resources.sort(sortOn('ecmrepositorytype', dir));
            if(colNumber == 3)
                that.ecmpartitions.resources.sort(sortOn('connectiondescr', dir));   
            if(colNumber == 4)
                that.ecmpartitions.resources.sort(sortOn('operationType', dir));   
            if(colNumber == 5)
                that.ecmpartitions.resources.sort(sortOn('status', dir));     
        },
        
        totalRows() {
            return this.partitions.total_count;
        },

        showDetails(rowNumber){
            const onepartition = this.partitions[rowNumber];
            if(onepartition)
            {
                const ecmrepositorytype = onepartition.ecmrepositorytype;
                const ecmrepositoryid = onepartition.ecmrepositoryid;
                const partitiondescription = onepartition.partitiondescription;
                const partitionid = onepartition.partitionid;
                const connectionid = onepartition.connectionID;
                const connectiondescr=onepartition.connectiondescr;
                const operationType = onepartition.operationType;
                var col=[];
                for (var k = 0 ; k < this.connections.length; k++ ) {
                    if(this.connections[k].ecmrepositoryid == ecmrepositoryid)
                    {
                        col.push(this.connections[k].description + "~" + this.connections[k].connectionid);
                    }
                }
                //if there is no collection - not details.
                if(operationType == -1 /*|| operationType == ''*/ || col.length == 0)
                {
                    //todo
                    //Partition 'b' was not crawled. There is no details. Show info message
                    showMessage(this, 'info', this.ecmResourceStrings.ttlDetails,'', true, this.ecmResourceStrings.txtExecutionDetails);
                }
                else
                {
                    const data = encodeURIComponent(ecmrepositorytype) + "/" + encodeURIComponent(ecmrepositoryid) + "/" + encodeURIComponent(partitiondescription) + "/" + encodeURIComponent(partitionid) + "/" + encodeURIComponent(col);
                    this.$router.push('/reports/rdbmscrawlerexecutions/rdbmspartitionexecutiondetails/'+ data);
                }                       
            }
        },
        
        getECMRepositoryStatus(ecmrepositoryid, partitionID) {
        const action = 'executionStatus?repositoryId=' +ecmrepositoryid + '&partitionId=' + partitionID;
        return axios.get('/mtm-gateway-api/v1/services/ecm/query/' + action, 
            {headers: {"Content-Type": "application/json; charset=UTF-8"}});
        },

        getlastindex(jobExecutionDetailslist, repoid, partitionid)
        {
            const len = jobExecutionDetailslist.length;
            var max = 0;
            var index = len - 1;
            var cnt=0;
            for(cnt=0;cnt<len;cnt++)
            {
                const item = jobExecutionDetailslist[cnt];
                if(item)
                {
                    const crawlerProcessId  = item.crawlerProcessId;
                    const repositoryIdx  = item.repositoryId;
                    const partitionIdx  = item.partitionId;
                    if (Number(crawlerProcessId) > Number(max) && (Number(repoid) == Number(repositoryIdx) && Number(partitionIdx) == Number(partitionid)))
                    {
                        max = crawlerProcessId;
                        index = cnt;
                    }
                }
            }
            return index;
        },

        async  getStatus(ecmrepositoryid, partitionID) {
            var that = this;
            try
            {         
                const res = await that.getECMRepositoryStatus(ecmrepositoryid, partitionID); 

                if(res && res.data && res.data.jobExecutionDetails)
                {
                    const jobExecutionDetailslist = res.data.jobExecutionDetails;
                    if(jobExecutionDetailslist !== undefined && jobExecutionDetailslist !== null)
                    {
                        const lenlist = jobExecutionDetailslist.length;
                        if(lenlist!=0)
                        {
                            const lastindex = that.getlastindex(jobExecutionDetailslist, ecmrepositoryid, partitionID);                                                                       
                            const crawleroperationdetails = jobExecutionDetailslist[lastindex];
                            if(crawleroperationdetails)
                            {
                                const repositoryIdx  = crawleroperationdetails.repositoryId;
                                const partitionIdx  = crawleroperationdetails.partitionId;
                                const connectionIdx  = crawleroperationdetails.ecmConnectionId;
                                const operationTypex  = crawleroperationdetails.operationType;
                                const isRunningx  = crawleroperationdetails.isRunning;
                                var isRunning = "";
                                if(crawleroperationdetails.isRunning != '0')
                                { 
                                    isRunning= 'Running';
                                }
                                else
                                {
                                    isRunning = 'Finished';
                                }
                                const isMaster  = crawleroperationdetails.isMaster;
                                var startDate  = '';
                                if(crawleroperationdetails.startDate)
                                {
                                    startDate = crawleroperationdetails.startDate;
                                    const d = new Date(startDate);
                                    startDate = d.toLocaleString(); 
                                }
                                var endDate = '';
                                if(crawleroperationdetails.endDate)
                                {
                                    endDate  = crawleroperationdetails.endDate;
                                    const d = new Date(endDate);
                                    endDate = d.toLocaleString(); 
                                }
                                var status = '-1';
                                if(crawleroperationdetails.status)
                                {
                                    status  = crawleroperationdetails.status;
                                }
                               
                                const numberThreads  = crawleroperationdetails.numberThreads;
                                const crawlerProcessId  = crawleroperationdetails.crawlerProcessId;
                                const oticEngineName  = crawleroperationdetails.oticEngineName;
                                
                                var result = that.ecmpartitions.resources.filter((el) => (el.partitionid == partitionID && el.ecmrepositoryid == ecmrepositoryid));
                                const resultnew = that.connections.filter((el) => (el.connectionid == connectionIdx && el.ecmrepositoryid == ecmrepositoryid));
                                var descr = '';
                                if(resultnew && resultnew.length > 0)
                                {
                                    descr = resultnew[0].description;
                                }
                                if(result && result.length > 0)
                                {
                                   for(var iItem = 0; iItem < result.length; iItem++)
                                    {
                                        if(result[iItem])
                                        {
                                            result[iItem].connectionid = connectionIdx;
                                            result[iItem].operationType = operationTypex;
                                            result[iItem].guioperationType = getguivalue('operationtype', operationTypex);
                                            result[iItem].isRunning = isRunning;
                                            result[iItem].connectiondescr = descr;
                                            result[iItem].isMaster = isMaster;
                                            result[iItem].startDate = startDate;
                                            result[iItem].endDate = endDate;
                                            result[iItem].status = status;
                                            result[iItem].numberThreads = numberThreads;
                                            result[iItem].crawlerProcessId = crawlerProcessId;
                                            result[iItem].oticEngineName = oticEngineName;
                                        }
                                    }
                                }
                            }
                        }
                        else
                        {
                            var result = that.ecmpartitions.resources.filter((el) => (el.partitionid == partitionID && el.ecmrepositoryid == ecmrepositoryid));
                            if (result && result.length > 0)
                            {
                                for(var k = 0; k < result.length; k++)
                                {
                                    result[k].guioperationType = "Not processed";
                                    result[k].operationType = "-1";
                                    result[k].connectionid = "-1";
                                    //result[k].connectiondescr = "";
                                }
                            }
                        }
                    }
                }
                 else{
                    var result = that.ecmpartitions.resources.filter((el) => (el.partitionid == partitionID && el.ecmrepositoryid == ecmrepositoryid));
                    if (result && result.length > 0)
                    {
                        for(var k = 0; k < result.length; k++)
                        {
                            result[k].guioperationType = "Not processed";
                            result[k].operationType = "-1";
                            result[k].connectionid = "-1";
                            //result[k].connectiondescr = "";
                        }
                    }
                }
            }
        
            catch (res1)
            {
                if(res1 && res1.response && res1.response.data)
                {
                    return  res.response.data;
                }
            }
        }
    },

    computed: {
        partitions() {
            return this.ecmpartitions.resources;
        }
    },

    mounted() {

        var breadcrumbs = [{
            name: 'reports',
            meta: { label: 'Event Dashboard' }
        },{
            name: 'ecm-executions',
            meta: { label: 'Executions' }
        }];
  
        this.$store.commit('breadcrumbs', breadcrumbs);
    },
   
    created() {
        var that = this;
        that.connections = [];
        that.ecmRepositories.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
                const ecmrepositorylist =  that.ecmRepositories.resources;
                if(ecmrepositorylist)
                {
                    const len = ecmrepositorylist.length;
                    if(len!=0)
                    {
                        for(var k=0; k<len; k++)
                        {
                            const oneecmrepo = ecmrepositorylist[k];
                            if(oneecmrepo)
                            {
                                const ecmrepositoryid = oneecmrepo.attributes.repositoryId
                                const ecmrepositorytype = oneecmrepo.attributes.repositoryType;
                                if(ecmrepositorytype == 'dbms_generic_v1')
                                {
                                    const configurationdatalist = oneecmrepo.attributes.configData;
                                    var connectiondescr = oneecmrepo.attributes.repositoryName; 
                                    if(configurationdatalist)
                                    {
                                        const configlen = configurationdatalist.length;
                                        if(configlen!=0)
                                        {
                                            for(var i=0; i<configlen; i++)
                                            {
                                                const oneelement = configurationdatalist[i];
                                                if(oneelement)
                                                {
                                                    var paramfullName = oneelement.name;
                                                    var connectionID = 0;
                                                    var partitionID = 0;//for partitions
                                                    var paramName = '';
                                                    
                                                    //parse name to see what we have
                                                    //could be one word
                                                    //repoParam.0.hostName, repoPartitionTask.0.folderPathOrId, repoExcludedFolder.1.folderPathOrId
                                                    const namesArray = paramfullName.split(".");
                                                    const lennames = namesArray.length;
                                                    if(lennames > 1)
                                                    {
                                                                                                                //connections  get to take description
                                                        if (namesArray[0] == "repoParam")
                                                        {
                                                            connectionID = namesArray[1]; 
                                                            paramName = namesArray[2]; 
                                                            var result = that.connections.filter((el) => (el.connectionid == connectionID && el.ecmrepositoryid == ecmrepositoryid));
                                                            
                                                            if (result && result.length == 0)
                                                            {
                                                                // not found - add
                                                                that.connections.push({
                                                                    "count":that.connections.length,
                                                                    "ecmrepositoryid":ecmrepositoryid,
                                                                    "ecmrepositorytype" : ecmrepositorytype,
                                                                    "connectionid" : connectionID,
                                                                    "description":'',
                                                                });
                                                                //get it
                                                                var resultnew = that.connections.filter((el) => (el.connectionid == connectionID));
                                                                if (resultnew && resultnew.length == 1)
                                                                {
                                                                    if(paramName == 'description')
                                                                    {
                                                                        resultnew[0].description = oneelement.value;
                                                                        if(oneelement.value == "")
                                                                            resultnew[0].description = connectiondescr;
                                                                        else
                                                                            connectiondescr = oneelement.value;
                                                                    }
                                                                }
                                                            }
                                                            else if (result && result.length == 1)
                                                            {
                                                                if(paramName == 'description')
                                                                {
                                                                    result[0].description = oneelement.value;
                                                                    if(oneelement.value == "")
                                                                        result[0].description = connectiondescr;
                                                                    else
                                                                        connectiondescr = oneelement.value;
                                                                }
                                                            } 
                                                        }

                                                        else if (namesArray[0] == "repoPartition")
                                                        {
                                                            partitionID = namesArray[1]; 
                                                            paramName = namesArray[2]; 
                                                            var result = that.ecmpartitions.resources.filter((el) => (el.partitionid == partitionID && el.ecmrepositoryid == ecmrepositoryid));
                                                            if (result && result.length == 0)
                                                            {
                                                                // not found - add
                                                                that.ecmpartitions.resources.push({
                                                                "count":that.ecmpartitions.resources.length,
                                                                "ecmrepositoryid":ecmrepositoryid,
                                                                "ecmrepositorytype" : ecmrepositorytype,
                                                                "partitionid" : partitionID,
                                                                "partitiondescription" : '',
                                                                "operationType":'',
                                                                "guioperationType":'',
                                                                "isRunning":'',
                                                                "connectionid":'',
                                                                "connectiondescr":connectiondescr,
                                                                });
                                                                
                                                                that.getStatus(ecmrepositoryid, partitionID);
                                                                var resultnew = that.ecmpartitions.resources.filter((el) => (el.partitionid == partitionID));
                                                                if (resultnew && resultnew.length == 1)
                                                                {
                                                                    if(paramName == 'description')
                                                                    {
                                                                        resultnew[0].partitiondescription = oneelement.value;
                                                                    }
                                                                }
                                                            }
                                                            else if (result && result.length == 1)
                                                            {
                                                                if(paramName == 'description')
                                                                {
                                                                    result[0].partitiondescription = oneelement.value;
                                                                }
                                                            } 
                                                        }

                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
               
                that.loaded = true;
            }
        )
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
            }
            else  if(err.response)
            {
                this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
        });
    }
}

</script>
